import { useParams, useNavigate } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import CrewForm from "../components/CrewForm";
import type { CrewMember } from "../types/database";

export default function CrewNew() {
  const { orgId } = useParams();
  const navigate = useNavigate();
  const { currentOrganization } = useAuth();

  // Handle successful form submission
  const handleSuccess = (crewMember: CrewMember) => {
    navigate(`/org/${orgId}/crew/${crewMember.id}`);
  };

  if (!orgId || !currentOrganization) {
    return (
      <div className="flex items-center justify-center h-64">
        <div className="text-red-500">
          Organization not found. Please go back and try again.
        </div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      {/* Header */}
      <div className="flex justify-between items-center pb-5 border-b border-gray-200">
        <div>
          <h1 className="text-2xl font-bold text-gray-900">
            Add New Crew Member
          </h1>
          <p className="mt-1 text-sm text-gray-500">
            Create a new crew member profile with all their details
          </p>
        </div>
      </div>

      {/* Form */}
      <div className="bg-white shadow-sm rounded-lg p-6">
        <CrewForm onSuccess={handleSuccess} orgId={orgId} />
      </div>
    </div>
  );
}
